module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"EssentialDesc":"既存のデータをプラットフォームに統合したい方はこちら","Essential":"ベーシックプラン","Pro":"プロプラン","Enterprise":"エンタプライズプラン","ProDesc":"店舗分析のための基本パッケージ。IoT機器との連携が含まれます","EnterpriseDesc":"高度なセキュリティオプションを含めた店舗分析パッケージ","contact":"問い合わせる","StorePerMonth":"月額/１店舗"}}')
  delete Component.options._Ctor
}
